<template>
  <div id="tools-page">
      <Header></Header>
      <div class="tools-page-content">
          <div class="tools-table">
              <ToolsTable ref="toolsTable" :tools="tools" @pageChanged="changePage" @toolSelected="selectTool"></ToolsTable>
          </div>
          <div class="tool-editor">
              <ToolEditor ref="toolEditor" @updated="initialize"></ToolEditor>
          </div>
      </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import ToolsTable from "@/components/production-planning/ToolsTable.vue";
import ToolEditor from "@/components/production-planning/ToolEditor.vue";
import Tool from "@/models/Tool.js";
export default {
    name: "tools-page",
    components: {
        Header,
        ToolsTable,
        ToolEditor
    },
    data(){
        return {
            tools: [],
            page: 1
        }
    },
    created(){
        this.initialize();
    },
    methods: {
        async initialize(){
            const { tools, page, pages } = await Tool.loadTools(this.page);
            this.tools = tools;
            this.$refs.toolsTable.$data.page = page;
            this.$refs.toolsTable.$data.pages = pages;
        },
        changePage(page){
            this.page = page;
            this.initialize();
        },
        selectTool(tool){
            this.$refs.toolEditor.selectTool(tool);
        }
    }
}
</script>

<style scoped>
.tools-page-content{
    position: absolute;
    width: 100%;
    height: calc(100% - 70px);
}
.tools-table{
    position: relative;
    padding-top: 20px;
    padding-left: 20px;
    width: 30%;
    height: 100%;
}
.tool-editor{
    position: absolute;
    top: 0;
    left: 30%;
    padding-top: 20px;
    padding-left: 10px;
    width: 70%;
    height: 100%;
}
</style>